import { useTranslation } from "react-i18next";
import {SearchInput, TextInputField} from "../../components/FormComponents";
import { useLoginStore } from "../../store/useLoginStore";
import { ValidatableLoginData } from "../../types";
import { LOGIN_PAGE_NS } from "./i18n";

export const LoginFormField = <K extends keyof ValidatableLoginData, T extends ValidatableLoginData[K]>(args: { propertyName: K; }) => {
  const { propertyName } = args;
  const { t } = useTranslation(LOGIN_PAGE_NS, { keyPrefix: `form.${propertyName}` });
  const {
    loginData,
    validationErrors,
    updateLoginData
  } = useLoginStore();

  const isPasswordField = propertyName === 'password';
  const isRankField = propertyName === 'rank';
  const hideHint = isPasswordField || isRankField || propertyName === 'vesselName';

  const textInput = <TextInputField
      error={!!validationErrors[propertyName]}
      value={loginData[propertyName] ?? ''}
      onChange={evt => updateLoginData({ [propertyName]: evt.target.value as T })}
      placeholder={t(`placeholder`)}
      label={t(`label`)}
      hint={hideHint ? undefined : t(`hint`)}
      required
      inputType={isPasswordField ? "password" : "text"}
  />;

  const selectInput = <SearchInput
      value={loginData.rank ?? ''}
      onChange={evt => updateLoginData({ [propertyName]: evt.target.value as T })}
      options={["Captain", "Chief Engineer"]}
      required
      label={t(`label`)}
  />

  return isRankField ? selectInput : textInput;
};
